//function that checks if numbers are in correct ascending order
export const isAscending = (array) => {
  return array.slice(1).every((number, idx) => number >= array[idx]);
};
